<!-- 自动拉群 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="自动拉群">
    </el-page-header>
    <div class="container Mmain" >
      <el-form ref="ruleForm" :model="form" :rules="rules"  label="right" label-width="12rem">
        <div class="form-header">
          <el-form-item label="任务名称：" prop="name">
            <el-input clearable style="width:47rem" placeholder="请输入名称" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="自动验证：" prop="skip_verify">
            <el-radio v-model="form.skip_verify" :label="1">是</el-radio>
            <el-radio v-model="form.skip_verify" :label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="使用人员：" prop="user">
            <div class="person">
              <el-tag style="margin: rem 12px 0 0"  effect="plain" v-for="item of names" :key="item">{{ item
              }}</el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="onAdd">前往添加</el-button>
          </el-form-item>
          <el-form-item label="入群内容：" prop="content">
            <el-input clearable style="width: 47rem" placeholder="请输入内容" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="选择群活码：" prop="url">
            <div class="chatCode">
              <el-image v-if="form.url" style="width: 10rem; height: 10rem" :src="form.url" :preview-src-list="[form.url]"
                fit="scale-down"></el-image>
              <el-button type="text" style="padding-left:.6rem  !important;text-align: left;"  @click="onSelectChat">选择群活码</el-button>
            </div>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input clearable style="width: 47rem" placeholder="请输入备注" v-model="form.remark"></el-input>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="25px">
            <el-button v-if="this.$route.query.id"  type="primary" @click="onSubmit()" :disabled="isLock">确定编辑</el-button>
            <el-button v-else  type="primary" @click="onSubmit()" :disabled="isLock">立即创建</el-button>
          
            <!-- <el-button style="margin-left: 2rem" @click="$router.back()"
              >取消</el-button
              > -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog title="选择群活码" center :visible.sync="chatShow">
      <div>
        <div>
          <nav class="navbar">
            <div class="nav-l">
              <el-input clearable style="width: 28rem; margin-left: 24px" placeholder="请输入活码名称"
                prefix-icon="el-icon-search" v-model="q" @change="getList()">
                <el-button slot="append" @click="getList()">查询</el-button>
              </el-input>
            </div>
            <div class="nav-r">
              <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" @change="getList()">
              </el-date-picker>
            </div>
          </nav>

          <div class="table">
            <el-table :data="list" style="margin-top: 2rem" border highlight-current-row
               @row-click="rowClick">
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio :label="scope.row.id" v-model="radioId">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="群活码名称">
              </el-table-column>
              <el-table-column prop="code_image" label="群活码图片">
                <template slot-scope="scope">
                  <el-image style="width: 7rem; height: 7rem" :src="scope.row.code_image"
                    :preview-src-list="[scope.row.code_image]" fit="scale-down"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="gruop_count" label="上传群数量">
              </el-table-column>
              <el-table-column prop="author" label="创建人"></el-table-column>
              <el-table-column prop="createtime" label="创建时间">
              </el-table-column>
            </el-table>
            <div class="paging">
              <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                :page-sizes="[10, 20, 50, 100]" @pagination="getList" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="chatShow = false">取 消</el-button>
        <el-button type="primary" @click="chatShow = false">确 定</el-button>
      </div>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "setGroupsDetail",
  components: {
    rightPeople
  },
  data() {
    return {
      isLock: false,//控制立即创建按钮状态
      form: {
        name: "",
        skip_verify: 1,
        remark: "",
        user: "",
        content: "",
        media_id: "",
        url: "",
        userid: "",
      },
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        skip_verify: [
          { required: true, message: "请选择是否自动验证", trigger: "blur" },
        ],
        user: [{ required: true, message: "请选择使用人员", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        url: [{ required: true, message: "请选择群活码", trigger: "blur" }],
      },
      checkList: [],
      module: "",
      checkbox: false,
      chatShow: false,
      list: [],
      total: 0,
      names: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      time: "",
      star_time: "",
      end_time: "",
      multipleSelection: [],
      radioId: 0,
      currentRow: {},
    };
  },
  computed: {},

  mounted() {
    if (this.$route.query.id) {
      this.getData();
    }
    this.getList();
  },
  methods: {

    rowClick(row) {
      this.radioId = row.id;
      this.form.url = row.code_image;
      this.form.media_id = row.media_id;
      
    },
    async getList() {
      if (Array.isArray(this.time)) {
        this.star_time = new Date(this.time[0]).getTime();
        this.end_time = new Date(this.time[1]).getTime();
        this.star_time = this.star_time / 1000;
        this.end_time = this.end_time / 1000;
      } else {
        this.star_time = "";
        this.end_time = "";
      }
      const { data: res } = await this.axios({
        url: "/crm/GroupLiveCodeTwo/LiveCodesList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          star_time: this.star_time,
          end_time: this.end_time,
          page: this.listQuery.page,
          number_page: this.listQuery.limit
        }),
      });
      if (res.code == 1) {
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    onSelectChat() {
      this.chatShow = true;
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/ActiveCodeGroup/getActiveCodeone",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      if (res.code == 1) {
        console.log(d);
        const d = res.data;
        this.form.name = d.name;
        this.form.skip_verify = d.skip_verify;
        this.form.user = d.user;
        this.form.content = d.content;
        this.form.url = d.url;
        this.form.media_id = d.media_id;
        this.form.remark = d.remark;
        this.form.config_id = d.config_id;
        this.names = d.user_name_array;
        this.form.userid = d.user;
        this.checkList = d.user_name_array.map((item, index) => {
          return {
            name: item,
            userid: d.user_array[index],
          };
        });
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    goBack() {
      this.$router.back();
    },
    onAdd() {
      this.module = "getAddressBook";
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getUserLists":
          const userId = [];
          const users = [];
          person.map((item) => {
            userId.push(item.userid);
            users.push(item.name);
          });
          this.form.userid = userId.join();
          this.form.user = users.join(",");
          this.names = users;
          break;
        case "getAddressBook":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.form.userid = userid.join();
          this.form.user = user.join(",");
          this.names = user;
          break;
        default:
          break;
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.isLock = true;
          this.submitForm();
          setTimeout(() => {
            this.isLock = false
          }, 1000)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitForm() {
      let url = "/crm/ActiveCodeGroup/addActiveCode";
      const params = {
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        name: this.form.name,
        skip_verify: this.form.skip_verify,
        user: this.form.userid,
        remark: this.form.remark,
        content: this.form.content,
        media_id: this.form.media_id,
        url: this.form.url,
      };
      if (this.$route.query.id) {
        // 编辑
        url = "/crm/ActiveCodeGroup/editActiveCode";
        params.id = this.$route.query.id;
        params.config_id = this.form.config_id;
      }
      const { data: res } = await this.axios({
        url,
        method: "POST",
        data: this.qs.stringify(params),
      });
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.goBack();
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style  scoped>
.chatCode {
  display: flex;
  flex-direction: column;
  
}
.form-footer {
  margin-top: 4rem;
  padding-top: 4rem;
  border-top: 1px solid #ebeef5;
}
.Mmain{
background-color: #ffffff;
border-radius: .8rem;
padding: 4rem 2rem;
}
.el-form-item{
  margin-bottom: 4rem;
}
</style>